var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgUnlikeThumb = function SvgUnlikeThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1551,25.6108 L13.4544,20.7521 C13.1237,20.4276 12.9359,19.9803 12.9359,19.5155 L12.9359,10.754 C12.9359,9.7893 13.7404,9 14.7237,9 L19.7295,9 C20.4446,9 21.0882,9.421 21.3653,10.0612 L24.2794,16.7353 C25.0392,18.4718 23.743,20.4013 21.8212,20.4013 L18.5585,20.4013 L19.4077,24.4181 C19.4971,24.8566 19.363,25.3039 19.0412,25.6196 C18.5138,26.1283 17.6735,26.1283 17.1551,25.6108 Z M8.2877,9 C9.271,9 10.0755,9.7893 10.0755,10.754 L10.0755,17.7702 C10.0755,18.735 9.271,19.5243 8.2877,19.5243 C7.3045,19.5243 6.5,18.735 6.5,17.7702 L6.5,10.754 C6.5,9.7893 7.3045,9 8.2877,9 Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgUnlikeThumb);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/unlike-thumb.4973e2ec4746794085865f3361a08117.svg";